import React from "react";
import styled from "styled-components";
import { DropdownButton } from "../UI/Button/Button";
import "react-datepicker/dist/react-datepicker.css";
import StyledDatePicker from "../UI/StyledDatePicker/StyledDatePicker";
// import "../../../aat/components/Filter/_datepicker.css";

const DateRangePickerWrap = styled.div`
    box-sizing: border-box;
    color: var(--form-input-color, currentColor);
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;

    .btn-dropdown--start-date {
        padding-right: 1.2rem;
        overflow: visible;
        &:after {
            display: none;
        }
    }
    .btn-dropdown--end-date {
        padding-left: 1.2rem;
        overflow: visible;
        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: -5px;
            width: 10px;
            height: 1px;
            background-color: currentColor;
        }
        &:after {
            display: none;
        }
    }
`;

interface DateRangePickerProps
{
    startDate?: Date;
    endDate?: Date;
    startDateLabel: string;
    endDateLabel: string;
    onSubmit: (startDate?: Date, endDate?: Date) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = (props: DateRangePickerProps) =>
{
    const { startDate, endDate, startDateLabel, endDateLabel } = props;

    const handleStartDateChange = (date: Date) =>
    {
        props.onSubmit(date, endDate);
    };

    const handleEndDateChange = (date: Date) =>
    {
        props.onSubmit(startDate, date);
    };

    const ButtonInput = React.forwardRef<HTMLButtonElement,
        React.ButtonHTMLAttributes<{}> & { value?: string; label: string }>(
            function myButtonInput({ value, onClick, label }, ref)
            {
                const renderLabel = () =>
                {
                    return { __html: value || label };
                };

                return (
                    <DropdownButton ref={ref}
                        type="button"
                        className="btn-dropdown--start-date"
                        onClick={onClick}
                        dangerouslySetInnerHTML={renderLabel()} />
                );
            });

    return (
        <DateRangePickerWrap>
            <StyledDatePicker
                selectedDate={startDate}
                handleDateChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat={"dd MMM yyyy"}
                customInput={<ButtonInput label={startDateLabel || "Vælg start dato"} />}
            />
            <StyledDatePicker
                selectedDate={endDate}
                handleDateChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat={"dd MMM yyyy"}
                customInput={<ButtonInput label={endDateLabel || "Vælg slut dato"} />}
            />
        </DateRangePickerWrap>
    );
};

export default DateRangePicker;